import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import type ResumePersonalInfo from "@/interface/ResumePersonalInfo";
import type MultiChannelLink from "@/interface/MultiChannelLink";

export default function setOnBoardInfo(
  ccFormValue: Ref<FormCC>,
  prop: any,
  resumeInfo: Ref<ResumePersonalInfo>,
  multiChannel: Ref<MultiChannelLink>,
  filteredMobile: (number: string) => string
): void {
  if ((prop.type == "FINPLUS" || prop.type == "CR_SL") && prop.webFormDetails) {
    //Search CIF use
    if (prop.refNo) ccFormValue.value.refNo = prop.refNo;
    if (prop.webFormDetails.webFormDetails.oriBasicInformation.idTypeCode)
      resumeInfo.value.idType =
        prop.webFormDetails.webFormDetails.oriBasicInformation.idTypeCode;
    if (prop.webFormDetails.webFormDetails.oriBasicInformation.idNo)
      resumeInfo.value.idNo =
        prop.webFormDetails.webFormDetails.oriBasicInformation.idNo;
    if (prop.webFormDetails.webFormDetails.oriBasicInformation.emailAddress)
      resumeInfo.value.email =
        prop.webFormDetails.webFormDetails.oriBasicInformation.emailAddress;
    if (
      prop.webFormDetails.webFormDetails.oriBasicInformation.mobileCountryCode
    )
      resumeInfo.value.countryCode = filteredMobile(
        prop.webFormDetails.webFormDetails.oriBasicInformation.mobileCountryCode
      );
    if (prop.webFormDetails.webFormDetails.oriBasicInformation.mobileNumber)
      resumeInfo.value.mobileNo =
        prop.webFormDetails.webFormDetails.oriBasicInformation.mobileNumber;
    if (prop.webFormDetails.webFormDetails.oriBasicInformation.fullName)
      ccFormValue.value.basicInformation.name =
        prop.webFormDetails.webFormDetails.oriBasicInformation.fullName.toUpperCase();
    if (prop.webFormDetails.merchantCode)
      multiChannel.value.mc = prop.webFormDetails.merchantCode;
    if (prop.webFormDetails.applicationChannelCode)
      multiChannel.value.acc = prop.webFormDetails.applicationChannelCode;
  }
}
